import { getOrdinalSuffix } from 'Policies/utils/helpers/helpers';

export const dayOfWeekOptions = {
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
};

export const generateSemiMonthlyOptions = () => {
  const options: { [key: string]: string } = {};
  for (let i = 1; i <= 14; i++) {
    const firstDay = i;
    const secondDay = i + 14;
    const firstOrdinal = getOrdinalSuffix(firstDay);
    const secondOrdinal = getOrdinalSuffix(secondDay);
    options[`${firstDay},${secondDay}`] = `${firstOrdinal}, ${secondOrdinal}`;
  }
  return options;
};

export const generateMonthlyOptions = () => {
  const options: { [key: string]: string } = {};
  for (let i = 1; i <= 31; i++) {
    options[i.toString()] = getOrdinalSuffix(i);
  }
  return options;
};
